import React, { useState, useEffect } from "react";
import io from "socket.io-client";
import { GoDotFill } from "react-icons/go";

const DashboardSuperAdmin = ({ user, data }) => {
  const stats = data?.stats || {};
  const settings = data?.settings;
  const recentWinners = data?.recentWinners || [];

  const [gameStatus, setGameStatus] = useState({
    game_3min: true,
    game_5min: true,
  });

  useEffect(() => {
    if (settings && (settings.game_3min !== undefined || settings.game_5min !== undefined)) {
      setGameStatus((prev) => ({
        ...prev,
        ...(settings.game_3min !== undefined && { game_3min: !!settings.game_3min }),
        ...(settings.game_5min !== undefined && { game_5min: !!settings.game_5min }),
      }));
    }
  }, [data?.settings]);

  useEffect(() => {
    const s = io(process.env.REACT_APP_NODE_URL, { transports: ["websocket"] });
    s.on("gameStatusChange", (payload) => {
      if (payload && (payload.game_3min !== undefined || payload.game_5min !== undefined)) {
        setGameStatus((prev) => ({
          ...prev,
          ...(payload.game_3min !== undefined && { game_3min: !!payload.game_3min }),
          ...(payload.game_5min !== undefined && { game_5min: !!payload.game_5min }),
        }));
      }
    });
    return () => s.disconnect();
  }, []);

  return (
    <>
      <div className="dashboard-grid">
        <div className="stat-card">
          <div className="stat-icon">🔥</div>
          <div className="stat-content">
            <h3>Running Sessions</h3>
            <p className="stat-game-value">
              3min{" "}
              <span className={gameStatus.game_3min ? "live" : "stopped"}>
                <GoDotFill />
                {gameStatus.game_3min ? "Live" : "Stopped"}
              </span>
            </p>
            <p className="stat-game-value">
              5min{" "}
              <span className={gameStatus.game_5min ? "live" : "stopped"}>
                <GoDotFill />
                {gameStatus.game_5min ? "Live" : "Stopped"}
              </span>
            </p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">📊</div>
          <div className="stat-content">
            <h3>Today Sessions</h3>
            <p className="stat-value">{stats.todaySessionsCount ?? 0}</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🏆</div>
          <div className="stat-content">
            <h3>Today Winners</h3>
            <p className="stat-value">{stats.todayWinnersCount ?? 0}</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">👥</div>
          <div className="stat-content">
            <h3>Total Users</h3>
            <p className="stat-value">{stats.totalUsersCount ?? 0}</p>
          </div>
        </div>
      </div>

      {settings && (
        <div className="dashboard-section">
          <h2>Settings Summary</h2>
          <div className="settings-summary">
            <span>Yantra Amount: {settings.yantra_amount}</span>
            <span>Winning Amount: {settings.winning_amount}</span>
            <span>Difference: {settings.difference}</span>
            <span>3min: {gameStatus.game_3min ? "On" : "Off"}</span>
            <span>5min: {gameStatus.game_5min ? "On" : "Off"}</span>
          </div>
        </div>
      )}

      <div className="recent-activity">
        <h2>Recent Winner Sessions</h2>
        <div className="activity-list">
          {recentWinners.length === 0 ? (
            <p className="activity-empty">No recent winner sessions.</p>
          ) : (
            recentWinners.map((w) => (
              <div className="activity-item" key={w.id}>
                <span className="activity-time">
                  {w.end_time ? new Date(w.end_time).toLocaleString() : "—"}
                </span>
                <span className="activity-desc">
                  Session #{w.session_no} ({w.game_type}) — 
                  {w.winner_type === "JACKPOT" ? "Multi Winner-" : 
                  w.winner_type === "JACKPOTX" ? `Jackpot(${w.winner_x})-` : ''}
                  {w.winner_yantra.length > 0 ? w.winner_yantra.join(" | ") : ""}
                </span>
                <span className="activity-result won">
                  ₹{Number(w.winning_amount || 0).toFixed(2)}
                </span>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardSuperAdmin;
